<template>
  <b-container fluid>
    <div v-if="callActivityData">
      <p class="d-flex align-items-center gap-3">
        <span class="fw-bold">Call Id: </span>
        <span>{{ callActivityData.id }}</span>
      </p>
      <p class="d-flex align-items-center gap-3">
        <span class="fw-bold">Status: </span>
        <span>{{ callActivityData.status }}</span>
      </p>
      <p class="d-flex align-items-center gap-3">
        <span class="fw-bold">Duration: </span>
        <span>{{ callActivityData.duration }}</span>
      </p>
      <p class="d-flex align-items-center gap-3">
        <span class="fw-bold">Cost: </span>
        <span>
          ${{
            callActivityData.invoiceAmount
              ? callActivityData.invoiceAmount
              : 0
          }}
        </span>
      </p>
      <p class="d-flex align-items-center gap-3">
        <span class="fw-bold">Interpreter: </span>
        <span>
          {{ callActivityData.interpreterName }} {{ callActivityData.interpreterNumber }}
        </span>
      </p>
      <p class="d-flex align-items-center gap-3">
        <span class="fw-bold">Requester: </span>
        <span>{{ callActivityData.requestorName }}</span>
      </p>
      <p class="d-flex align-items-center gap-3">
        <span class="fw-bold">Rating: </span>
        <span>
          {{ callActivityData.rating ? callActivityData.rating : 0 }} / 5
        </span>
      </p>
      <p class="d-flex align-items-center gap-3">
        <span class="fw-bold">Type: </span>
        <span class="text-capitalize">{{ callActivityData.type }}</span>
      </p>
      <p class="d-flex align-items-center gap-3">
        <span class="fw-bold">Service: </span>
        <span>{{ callActivityData.service }}</span>
      </p>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "CallActivitiesDetails",
  props: {
    callActivityData: Object,
  }
};
</script>
